/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 * Sort list of cars by one of the following criteria
 */
export enum CarSort {
  CREATED_AT = 'CREATED_AT',
  DISCOUNT = 'DISCOUNT',
  PRICE = 'PRICE',
  TITLE = 'TITLE'
}

/**
 * Car variant
 */
export enum CarVariant {
  CAR = 'CAR',
  MOTORBIKE = 'MOTORBIKE'
}

/**
 * Car parameter names
 */
export enum ParameterWithOptions {
  ADDITIONAL_INFO = 'ADDITIONAL_INFO',
  AIRBAGS = 'AIRBAGS',
  AIR_CONDITIONING = 'AIR_CONDITIONING',
  BODY = 'BODY',
  CAR_RADIO = 'CAR_RADIO',
  COLOR = 'COLOR',
  COMFORT_EQUIPMENT = 'COMFORT_EQUIPMENT',
  DRIVE = 'DRIVE',
  ELECTRICAL_WINDOWS = 'ELECTRICAL_WINDOWS',
  EMISSION_CLASS = 'EMISSION_CLASS',
  FUEL = 'FUEL',
  GEARBOX = 'GEARBOX',
  HEATED_SEATS = 'HEATED_SEATS',
  MANUFACTURER = 'MANUFACTURER',
  MODEL = 'MODEL',
  MONTH = 'MONTH',
  NUMBER_OF_DOORS = 'NUMBER_OF_DOORS',
  NUMBER_OF_SEATS = 'NUMBER_OF_SEATS',
  OTHER_EQUIPMENT = 'OTHER_EQUIPMENT',
  PARKING_SENSORS = 'PARKING_SENSORS',
  SAFETY_EQUIPMENT = 'SAFETY_EQUIPMENT',
  STATE = 'STATE',
  YEAR = 'YEAR'
}

/**
 * Option for setting sort direction
 */
export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

/**
 * Filter list of cars by following attributes
 */
export interface CarsFilter {
  readonly includeInactive?: boolean | null;
  readonly category?: string | null;
  readonly manufacturer?: string | null;
  readonly models?: ReadonlyArray<string | null> | null;
  readonly yearFrom?: number | null;
  readonly yearTo?: number | null;
  readonly mileageFrom?: number | null;
  readonly mileageTo?: number | null;
  readonly priceFrom?: number | null;
  readonly priceTo?: number | null;
  readonly fuel?: ReadonlyArray<string> | null;
  readonly gearbox?: ReadonlyArray<string> | null;
  readonly drive?: ReadonlyArray<string> | null;
  readonly sold?: boolean | null;
  readonly cursor?: string | null;
  readonly discountOfWeek?: boolean | null;
  readonly search?: string | null;
}

/**
 * Input for creating a new car
 */
export interface CreateCarInput {
  readonly authenticityReport?: any | null;
  readonly images?: ReadonlyArray<any> | null;
  readonly active?: boolean | null;
  readonly manufacturer: string;
  readonly model: string;
  readonly title: string;
  readonly categories: ReadonlyArray<string>;
  readonly year: number;
  readonly month?: number | null;
  readonly state: string;
  readonly mileage: number;
  readonly price: number;
  readonly discount: number;
  readonly automaticDiscount?: boolean | null;
  readonly vatDeduction?: boolean | null;
  readonly body?: string | null;
  readonly vin?: string | null;
  readonly color?: string | null;
  readonly metallic?: boolean | null;
  readonly numDoors?: number | null;
  readonly numSeats?: number | null;
  readonly fuel: string;
  readonly emissionClass?: string | null;
  readonly engineVolume?: number | null;
  readonly enginePower: number;
  readonly gearbox: string;
  readonly drive?: string | null;
  readonly consumptionCity?: number | null;
  readonly consumptionOutside?: number | null;
  readonly consumptionCombined?: number | null;
  readonly technicalControl?: any | null;
  readonly emissionControl?: any | null;
  readonly safetyEquipment?: ReadonlyArray<string> | null;
  readonly comfortEquipment?: ReadonlyArray<string> | null;
  readonly otherEquipment?: ReadonlyArray<string> | null;
  readonly highlights?: ReadonlyArray<string> | null;
  readonly airbags?: ReadonlyArray<string> | null;
  readonly carRadio?: string | null;
  readonly airConditioning?: string | null;
  readonly electricalWindows?: string | null;
  readonly heatedSeats?: string | null;
  readonly parkingSensors?: string | null;
  readonly additionalInfo?: ReadonlyArray<string> | null;
  readonly text?: string | null;
  readonly autoskladActive?: boolean | null;
  readonly autoskladPrice?: number | null;
  readonly autoskladValidUntil?: any | null;
}

/**
 * Definition for creating new car template
 */
export interface CreateTemplateInput {
  readonly name?: string | null;
  readonly manufacturer?: string | null;
  readonly model?: string | null;
  readonly title?: string | null;
  readonly categories?: ReadonlyArray<string> | null;
  readonly year?: number | null;
  readonly month?: number | null;
  readonly state?: string | null;
  readonly mileage?: number | null;
  readonly price?: number | null;
  readonly discount?: number | null;
  readonly vatDeduction?: boolean | null;
  readonly body?: string | null;
  readonly vin?: string | null;
  readonly color?: string | null;
  readonly metallic?: boolean | null;
  readonly numDoors?: number | null;
  readonly numSeats?: number | null;
  readonly fuel?: string | null;
  readonly emissionClass?: string | null;
  readonly engineVolume?: number | null;
  readonly enginePower?: number | null;
  readonly gearbox?: string | null;
  readonly drive?: string | null;
  readonly consumptionCity?: number | null;
  readonly consumptionOutside?: number | null;
  readonly consumptionCombined?: number | null;
  readonly technicalControl?: any | null;
  readonly emissionControl?: any | null;
  readonly safetyEquipment?: ReadonlyArray<string> | null;
  readonly comfortEquipment?: ReadonlyArray<string> | null;
  readonly otherEquipment?: ReadonlyArray<string> | null;
  readonly highlights?: ReadonlyArray<string> | null;
  readonly airbags?: ReadonlyArray<string> | null;
  readonly carRadio?: string | null;
  readonly airConditioning?: string | null;
  readonly electricalWindows?: string | null;
  readonly heatedSeats?: string | null;
  readonly parkingSensors?: string | null;
  readonly additionalInfo?: ReadonlyArray<string> | null;
  readonly text?: string | null;
}

/**
 * Filter for paratemeter values
 */
export interface ParameterValuesFilter {
  readonly variant?: CarVariant | null;
  readonly parent?: string | null;
  readonly inUseOnly?: boolean | null;
}

/**
 * Input for sending a new request
 */
export interface SendRequestInput {
  readonly name: string;
  readonly email: string;
  readonly phone?: string | null;
  readonly text: string;
  readonly car?: string | null;
  readonly monthlyPayment?: number | null;
}

/**
 * Input for editing details of a car
 */
export interface UpdateCarInput {
  readonly attachments?: ReadonlyArray<any> | null;
  readonly authenticityReport?: any | null;
  readonly images?: ReadonlyArray<any> | null;
  readonly active?: boolean | null;
  readonly soon?: boolean | null;
  readonly new?: boolean | null;
  readonly reserved?: boolean | null;
  readonly sold?: boolean | null;
  readonly manufacturer?: string | null;
  readonly model?: string | null;
  readonly title?: string | null;
  readonly categories?: ReadonlyArray<string> | null;
  readonly year?: number | null;
  readonly month?: number | null;
  readonly state?: string | null;
  readonly mileage?: number | null;
  readonly price?: number | null;
  readonly discount?: number | null;
  readonly discountOfWeek?: boolean | null;
  readonly automaticDiscount?: boolean | null;
  readonly automaticDiscountStartDate?: any | null;
  readonly vatDeduction?: boolean | null;
  readonly body?: string | null;
  readonly vin?: string | null;
  readonly color?: string | null;
  readonly metallic?: boolean | null;
  readonly numDoors?: number | null;
  readonly numSeats?: number | null;
  readonly fuel?: string | null;
  readonly emissionClass?: string | null;
  readonly engineVolume?: number | null;
  readonly enginePower?: number | null;
  readonly gearbox?: string | null;
  readonly drive?: string | null;
  readonly consumptionCity?: number | null;
  readonly consumptionOutside?: number | null;
  readonly consumptionCombined?: number | null;
  readonly technicalControl?: any | null;
  readonly emissionControl?: any | null;
  readonly safetyEquipment?: ReadonlyArray<string> | null;
  readonly comfortEquipment?: ReadonlyArray<string> | null;
  readonly otherEquipment?: ReadonlyArray<string> | null;
  readonly highlights?: ReadonlyArray<string> | null;
  readonly airbags?: ReadonlyArray<string> | null;
  readonly carRadio?: string | null;
  readonly airConditioning?: string | null;
  readonly electricalWindows?: string | null;
  readonly heatedSeats?: string | null;
  readonly parkingSensors?: string | null;
  readonly additionalInfo?: ReadonlyArray<string> | null;
  readonly text?: string | null;
  readonly autoskladActive?: boolean | null;
  readonly autoskladPrice?: number | null;
  readonly autoskladValidUntil?: any | null;
}

/**
 * Definition for updating car template
 */
export interface UpdateTemplateInput {
  readonly name?: string | null;
  readonly manufacturer?: string | null;
  readonly model?: string | null;
  readonly title?: string | null;
  readonly categories?: ReadonlyArray<string> | null;
  readonly year?: number | null;
  readonly month?: number | null;
  readonly state?: string | null;
  readonly mileage?: number | null;
  readonly price?: number | null;
  readonly discount?: number | null;
  readonly vatDeduction?: boolean | null;
  readonly body?: string | null;
  readonly vin?: string | null;
  readonly color?: string | null;
  readonly metallic?: boolean | null;
  readonly numDoors?: number | null;
  readonly numSeats?: number | null;
  readonly fuel?: string | null;
  readonly emissionClass?: string | null;
  readonly engineVolume?: number | null;
  readonly enginePower?: number | null;
  readonly gearbox?: string | null;
  readonly drive?: string | null;
  readonly consumptionCity?: number | null;
  readonly consumptionOutside?: number | null;
  readonly consumptionCombined?: number | null;
  readonly technicalControl?: any | null;
  readonly emissionControl?: any | null;
  readonly safetyEquipment?: ReadonlyArray<string> | null;
  readonly comfortEquipment?: ReadonlyArray<string> | null;
  readonly otherEquipment?: ReadonlyArray<string> | null;
  readonly highlights?: ReadonlyArray<string> | null;
  readonly airbags?: ReadonlyArray<string> | null;
  readonly carRadio?: string | null;
  readonly airConditioning?: string | null;
  readonly electricalWindows?: string | null;
  readonly heatedSeats?: string | null;
  readonly parkingSensors?: string | null;
  readonly additionalInfo?: ReadonlyArray<string> | null;
  readonly text?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
